/* global grecaptcha */

import 'modernizr'; // eslint-disable-line
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import '../vendor/bootstrap';

import tracking from '../modules/tracking';
import header from '../modules/header';
import toTop from '../modules/toTop';
import slider from '../modules/slider';
import cookieBar from '../modules/cookieBar';
import embedWrap from '../modules/embedWrap';
import accessibility from '../modules/accessibility';
import megaMenu from '../modules/megaMenu';
import calculatorModal from '../modules/calculatorModal';
import offerConnect from '../modules/offerConnect';
import searchComplete from '../modules/searchComplete';

const general = () => {
  tracking.initialize();
  accessibility.initialize();
  header.initialize();
  megaMenu();
  slider.initialize();
  cookieBar.initialize();
  embedWrap();
  calculatorModal.initialize();
  offerConnect.initialize();
  toTop.initialize();
  searchComplete.initialize();
  porta({
    messages: nl,
    onValid: (formElement) => {
      const recaptcha = formElement.querySelector('.js-g-recaptcha');

      if (recaptcha) {
        grecaptcha.execute(recaptcha.getAttribute('data-widget-id'));
        return false;
      }

      return true;
    },
  });
};

export default general;
